export type PlanPropertyForm = {
  categoryNm: string;
  boardNm: string;
  origin: string;
  planNm: string;
  executePeriod: string;
  cooperators: string;
  sharers: string;
  predict: string;
  details: string;
};

/** 업무 속성(계획) 표시용 — task/home·보드·HRE 공통 */
export const mapPlanToPropertyForm = (
  plan: Record<string, unknown> | null | undefined,
  options?: {
    coopUserList?: Array<{ userNm?: string }>;
    shareUserList?: Array<{ userNm?: string }>;
  },
): PlanPropertyForm => {
  const p = plan ?? {};
  const coop = options?.coopUserList;
  const share = options?.shareUserList;

  const startDt = String(p.startDt ?? '');
  const endDt = String(p.endDt ?? '');
  const executePeriod =
    String(p.executePeriod ?? '').trim() ||
    (startDt || endDt ? `${startDt} ~ ${endDt}`.trim() : '');

  return {
    categoryNm: String(p.categoryNm ?? ''),
    boardNm: String(p.boardNm ?? ''),
    origin: String(p.origin ?? ''),
    planNm: String(p.planNm ?? ''),
    executePeriod,
    cooperators:
      String(p.cooperators ?? '').trim() ||
      String(p.coopUserNms ?? '').trim() ||
      (Array.isArray(coop) ? coop.map(u => u.userNm).filter(Boolean).join(', ') : ''),
    sharers:
      String(p.sharers ?? '').trim() ||
      String(p.shareUserNms ?? '').trim() ||
      (Array.isArray(share) ? share.map(u => u.userNm).filter(Boolean).join(', ') : ''),
    predict: String(p.predict ?? ''),
    details: String(p.details ?? ''),
  };
};
